module.exports = __webpack_public_path__ + "static/media/car-tile.23bebd02.png";